import { render, staticRenderFns } from "./CantusMundiForum.vue?vue&type=template&id=586046e2&scoped=true&"
import script from "./CantusMundiForum.vue?vue&type=script&lang=ts&"
export * from "./CantusMundiForum.vue?vue&type=script&lang=ts&"
import style0 from "./CantusMundiForum.vue?vue&type=style&index=0&id=586046e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586046e2",
  null
  
)

export default component.exports